var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13615 0.802778C7.24354 0.695388 7.24354 0.521273 7.13615 0.413881C7.02876 0.306485 6.85464 0.306485 6.74724 0.413881L4.48216 2.67905C4.09163 3.06959 3.45845 3.06959 3.06792 2.67905L0.80283 0.413879C0.695439 0.306484 0.521319 0.306484 0.413928 0.413879C0.306539 0.521272 0.306542 0.695387 0.413935 0.802776L2.67911 3.06785C3.06966 3.45838 3.06966 4.09157 2.67911 4.4821L0.413937 6.74718C0.306543 6.85457 0.30654 7.02868 0.41393 7.13608C0.521321 7.24347 0.695439 7.24347 0.802832 7.13608L3.06793 4.87099C3.45846 4.48047 4.09162 4.48047 4.48214 4.87099L6.74724 7.13608C6.85464 7.24347 7.02876 7.24347 7.13615 7.13607C7.24354 7.02868 7.24354 6.85457 7.13614 6.74717L4.87105 4.48209C4.48052 4.09156 4.48052 3.45839 4.87105 3.06787L7.13615 0.802778Z",
    fill: "#3A3F52",
    stroke: "#3A3F52",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBtn);
export default __webpack_public_path__ + "static/media/remove-btn.4ce992b62487a058749d9b09d02dd1bf.svg";
export { ForwardRef as ReactComponent };